import Modal from "~/common/components/Modal";
import { Button, Stack, styled } from "~/common/mui";

import { URL_PARAM_OPEN_LOGIN_POPUP } from "~/features/auth/login/loginConstants";
import { useIsMinTabletSize } from "~/common/hooks/useMediaQuery";
import { IMG_STOPWATCH_GRAY } from "~/utils/url/staticResources";
import { useTranslation } from "react-i18next";

const Content = styled(Stack)(({ theme }) => ({
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  flex: 1,
  [theme.breakpoints.up("tablet")]: {
    textAlign: "left",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },
}));

export const SessionExpiredPopup = () => {
  const isMinTablet = useIsMinTabletSize();

  const reloadAndLogin = () => {
    window.sessionStorage.setItem(URL_PARAM_OPEN_LOGIN_POPUP, "true");
    window.location.reload();
  };

  const { t } = useTranslation();

  return (
    <Modal
      onClose={reloadAndLogin}
      title={t("popup.autologout.title")}
      footerChildren={
        <Button fullWidth={!isMinTablet} onClick={reloadAndLogin}>
          {t("popup.autologout.btn.login")}
        </Button>
      }
    >
      <Content>
        <div>{t("popup.autologout.content.expired")}</div>
        {!isMinTablet && <img style={{ width: 120 }} src={IMG_STOPWATCH_GRAY} />}
      </Content>
    </Modal>
  );
};
